import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Container from '../../../components/Containers/Container';
import ContainerPage from '../../../components/LayoutAuth/ContainerPage';
import { GOOGLE_CAPTCHA_API_KEY } from '../../../util';
import ValidateTemporalPasswordForm from './ValidateTemporalPasswordForm';

const ValidateTemporalPassword = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_CAPTCHA_API_KEY}>
      <Container>
        <ContainerPage>
          <ValidateTemporalPasswordForm />
        </ContainerPage>
      </Container>
    </GoogleReCaptchaProvider>
  );
};

export default ValidateTemporalPassword;
